// extracted by mini-css-extract-plugin
export default {"badgeContainer":"styles__badgeContainer___LBvoj","achievementContent":"styles__achievementContent___VsWmb"};